import { LoggerIcon } from '@app/modules/logger/LoggerIcon';
import { Box } from '@mui/material';

export function LoggerLoader() {
  return (
    <Box
      sx={{
        borderRadius: '50%',
        textAlign: 'center',
        fontSize: '2rem',
        color: '#92e1fe', // $color-AquaLight
        py: 14,
      }}
    >
      <LoggerIcon
        sx={{
          width: '100px',
          height: '100px',
          opacity: 0.7,
        }}
      />
    </Box>
  );
}
